export function getProfileDisplayName(profile) {
  if (!profile) {
    return "";
  }

  if (parseInt(profile.type) === 1) {
    return `${profile.prenom} ${profile.nom}`;
  }

  if (!profile.socType || profile.socType.toLowerCase() === "autre") {
    return profile.nom_societe;
  }

  return `${profile.socType} ${profile.nom_societe}`;
}
